/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useState } from 'react';
import { View, ScrollView } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import { scale, width } from '@components/frame';
import { isPhone } from '@helpers';
import ColorWrapper from '@styles/colors';
import { getBoxShadowStyle } from '@styles/shadow';
import Line from '@components/common/line';
import AnimatedHeader, { getHeight } from '@components/common/AnimatedHeader';
import Loading from '@components/loading';

import { getMachines } from '@reducers/machines';

const UserDetails = (props) => {
  const {
    machines: { machines },
    route: {
      params: { id },
    },
    getMachines,
    C,
  } = props;

  const currentMachine = machines.find((m) => m.machineId == id) || {};

  useEffect(() => {
    if (!currentMachine.machineId) {
      getMachines();
    }
  }, []);

  const { machineStatus = {} } = currentMachine;

  const machine = {
    name: {
      value: currentMachine.machineId,
      name: i18n.t('Machine id'),
      noArrow: true,
    },
    Status: {
      value: machineStatus.status,
      name: i18n.t('Status'),
      noArrow: true,
    },
    ncFileId: {
      value: machineStatus.ncFileId,
      name: i18n.t('ncFileId'),
      noArrow: true,
    },
    ncFileContentHash: {
      value: machineStatus.ncFileContentHash,
      name: i18n.t('ncFileContentHash'),
      noArrow: true,
    },
    ncFileStatus: {
      value: machineStatus.ncFileStatus,
      name: i18n.t('ncFileStatus'),
      noArrow: true,
    },
    subStatus: {
      value: machineStatus.subStatus,
      name: i18n.t('Program State'),
      noArrow: true,
    },
    executionMode: {
      value: machineStatus.executionMode,
      name: i18n.t('Execution Mode'),
      noArrow: true,
    },
    lastUpdatedOn: {
      value: machineStatus.lastUpdatedOn,
      name: i18n.t('Last Updated On'),
      noArrow: true,
    },
    expectedEndOn: {
      value: machineStatus.expectedEndOn,
      name: i18n.t('Expected On'),
      noArrow: true,
    },
    targetDuration: {
      value: machineStatus.targetDuration,
      name: i18n.t('Target Duration'),
      noArrow: true,
    },
  };

  return (
    <View style={{ height: '100%', width: '100%', backgroundColor: C('Background/Light/Detail'), alignItems: 'center' }}>
      <View style={{ width, height: '100%' }}>
        <AnimatedHeader
          {...{
            text: i18n.t('Machine Details'),
            C,
            animated: false,
            back: true,
            backgroundColor: 'Background/Light/Detail',
            borderBottomWidth: 0,
          }}
        />
        {currentMachine.machineId ? (
          <ScrollView contentContainerStyle={{ alignItems: 'center' }}>
            <View
              style={{
                width: '100%',
                paddingHorizontal: scale(isPhone ? 15 : 0),
                marginTop: getHeight() + scale(15),
                paddingBottom: scale(50),
                maxWidth: scale(720),
              }}
            >
              <View style={[getBoxShadowStyle({ type: 'Field', C }), { borderRadius: scale(10) }]}>
                {Object.keys(machine).map((item, index) => (
                  <Line
                    {...{
                      item: machine[item],
                      index,
                      array: Object.keys(machine),
                      C,
                      roundTop: index === 0,
                      roundBottom: Object.keys(machine).length - 1 === index,
                    }}
                    key={item}
                  />
                ))}
              </View>
            </View>
          </ScrollView>
        ) : (
          <Loading background={C('Background/Light/Detail')} />
        )}
      </View>
    </View>
  );
};

export default connect(({ machines }) => ({ machines }), {
  getMachines,
})(ColorWrapper(UserDetails));
